<div class="page-layout header-phone pb-3 align-items-center gap-3">
  <div *ngIf="showBackButton" class="app-back pointer" (click)="back()">
    <a>
      <i class="material-symbols-rounded">arrow_back_ios_new</i>
    </a>
  </div>

  <h1 class="fw-bold mb-0 header-title">
    {{ title$ | async }}
    <span *ngIf="smallTextTitle$ | async as smallTextTitle">({{ smallTextTitle }})</span>
  </h1>
  <ng-container *ngIf="showSubMenu$ | async as showSubMenu">
    <app-context-menu *ngIf="showSubMenu.show" [menuType]="showSubMenu.menuType" [data]="data" class="ms-auto"></app-context-menu>
  </ng-container>
  <ng-container *ngIf="showGroupAndChildrenFilter$ | async as showGroupAndChildrenFilter">
    <app-group-and-children-filter
      [showGroup]="showGroupAndChildrenFilter.showGroup"
      [showChildren]="showGroupAndChildrenFilter.showChildren"
      class="w-100"
    >
    </app-group-and-children-filter>
  </ng-container>
</div>
